export const ERR_TYPE_NOT_IMPLEMENTED = "Keypair type not implemented";
export const ERR_INVALID_KEYPAIR_TYPE = "Invalid keypair type";
//# sourceMappingURL=constants.js.map